module.exports = __webpack_public_path__ + "static/media/ANDLogo.171824bd.svg";